import React from "react";

import { Stack, styled, Typography } from "@mui/material";
import { IAssetClass } from "store/types";

import { ExistingRowForm } from "./ExistingRowForm";

interface Props {
  data: IAssetClass[];
  flex?: string;
  createNewAssetForm?: JSX.Element;
  hideSystemAssetClass?: boolean;
  bodyRef?: React.RefObject<HTMLDivElement>;
}

const StyledHeadText = styled(Typography)(() => ({
  fontSize: "14px",
  lineHeight: "16px",
  color: "#071F35",
  fontWeight: 500
}));

export const Section: React.FC<Props> = ({ data, hideSystemAssetClass = false, flex, createNewAssetForm, bodyRef }) => {
  return (
    <Stack
      sx={{ borderRadius: "8px", border: "1px solid #DBE8F5", overflow: "hidden", minHeight: 160, flexGrow: 1, flex }}
    >
      <Stack
        sx={{
          flexDirection: "row",
          flexShrink: 0,
          alignItems: "center",
          height: 32,
          minHeight: 32,
          gap: "12px",
          bgcolor: "#DBE8F5",
          p: "0 12px"
        }}
      >
        <StyledHeadText sx={{ flex: "20%" }}>Display Name</StyledHeadText>
        {!hideSystemAssetClass && <StyledHeadText sx={{ flex: "20%" }}>System Asset Class</StyledHeadText>}
        <StyledHeadText sx={{ flex: hideSystemAssetClass ? "80%" : "60%" }}>Sub Asset Classes</StyledHeadText>
      </Stack>
      <Stack sx={{ overflow: "auto", p: "8px 12px" }} ref={bodyRef}>
        {createNewAssetForm && createNewAssetForm}
        {data.map((assetClass) => (
          <ExistingRowForm key={assetClass.id} assetClass={assetClass} hideSystemAssetClass={hideSystemAssetClass} />
        ))}
      </Stack>
    </Stack>
  );
};
